import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Helmet from 'react-helmet';
import {
  Box,
  Button,
  Container,
  Heading,
  SimpleGrid,
  Spinner,
  Text,
  VStack,
} from '@chakra-ui/react';
import { fetchRewardSetsList } from '../utils/rewardsApi';
import RewardSetHero from '../components/CatalogoPremi/RewardSetHero';
import InfoCILPoints from '../components/CILPoints/InfoCILPoints';

const CatalogoPremi = () => {
  const [sets, setSets] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    let active = true;
    const run = async () => {
      try {
        setLoading(true);
        const list = await fetchRewardSetsList();
        if (!active) return;
        setSets(list);
        setError('');
      } catch (err) {
        if (!active) return;
        setSets([]);
        setError(err.message || 'Errore');
      } finally {
        if (active) setLoading(false);
      }
    };
    run();
    return () => {
      active = false;
    };
  }, []);

  return (
    <Box bg="gray.50" minH="70vh">
      <Helmet>
        <title>Catalogo premi | CIL</title>
        <meta name="description" content="Riscatta premi con i CIL Points" />
      </Helmet>

      <RewardSetHero sets={sets} altFallback="Catalogo premi CIL">
        <VStack align="flex-start" spacing={3} color="white" maxW="2xl">
          <Heading
            as="h1"
            size={{ base: 'xl', md: '2xl' }}
            textShadow="0 2px 12px rgba(0,0,0,0.45)"
          >
            Catalogo premi
          </Heading>
          <Text
            fontSize={{ base: 'md', md: 'lg' }}
            opacity={0.95}
            textShadow="0 1px 6px rgba(0,0,0,0.4)"
          >
            Usa i CIL Points accumulati sul tuo account per prenotare i premi
            disponibili.
          </Text>
          <Box pt={1}>
            <InfoCILPoints variant="link" tone="hero" />
          </Box>
        </VStack>
      </RewardSetHero>

      <Container
        maxW="container.xl"
        py={{ base: 8, md: 12 }}
        px={{ base: 4, md: 6 }}
      >
        {loading && (
          <Box textAlign="center" py={12}>
            <Spinner size="lg" color="purple.500" />
          </Box>
        )}

        {!loading && error && <Text color="red.500">{error}</Text>}

        {!loading && !error && sets.length === 0 && (
          <Text color="gray.600">Nessun set premi disponibile al momento.</Text>
        )}

        <SimpleGrid columns={{ base: 1, md: 2, lg: 3 }} spacing={6}>
          {sets.map((set) => (
            <Box
              key={set.documentId}
              bg="white"
              borderRadius="xl"
              overflow="hidden"
              boxShadow="md"
              border="1px solid"
              borderColor="gray.100"
              p={5}
              display="flex"
              flexDirection="column"
              h="full"
            >
              <Heading as="h2" size="md" mb={2} color="purple.800">
                {set.name}
              </Heading>
              {set.description && (
                <Text
                  fontSize="sm"
                  color="gray.600"
                  noOfLines={3}
                  mb={3}
                  flex={1}
                >
                  {set.description}
                </Text>
              )}
              <Text fontSize="sm" color="gray.500" mb={4}>
                {set.rewards?.length || 0} premi disponibili
              </Text>
              <Button
                as={Link}
                to={`/catalogo-premi/${set.slug}`}
                colorScheme="purple"
                size="sm"
                alignSelf="flex-start"
              >
                Vedi premi
              </Button>
            </Box>
          ))}
        </SimpleGrid>
      </Container>
    </Box>
  );
};

export default CatalogoPremi;
